import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link 
      to={`/product/${product.id}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        textDecoration: 'none',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image Container */}
      <div style={{
        position: 'relative',
        aspectRatio: '4 / 5',
        overflow: 'hidden',
        backgroundColor: '#1C1C1C',
      }}>
        <img 
          src={product.image_url} 
          alt={product.name}
          loading="lazy"
          decoding="async"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease-out',
            transform: isHovered ? 'scale(1.03)' : 'scale(1)',
            willChange: 'transform',
          }}
        />
        
        {/* Sold Out Badge */}
        {product.sold_out && (
          <div style={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            padding: '6px 10px',
            fontSize: '16px',
            color: '#F1F1F1',
            fontFamily: "'TASA Orbiter Display', sans-serif",
            letterSpacing: '0.02em',
          }}>
            Sold Out
          </div>
        )}
      </div>

      {/* Product Info */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0 10px 0',
      }}>
        <span style={{
          fontSize: '16px',
          fontWeight: '400',
          color: '#F1F1F1',
          fontFamily: "'TASA Orbiter Display', sans-serif",
        }}>
          {product.name}
        </span>
        <span style={{
          fontSize: '16px',
          fontWeight: '400',
          color: '#F1F1F1',
          fontFamily: "'TASA Orbiter Display', sans-serif",
        }}>
          € {product.price} 
        </span>
      </div>
    </Link>
  );
};

export default ProductCard;